export function BrandMark(): JSX.Element {
  return (
    <div className="brand-mark">
      <div>
        <p className="brand-mark__eyebrow">Albion Guild Mass Portal</p>
        <h1 className="brand-mark__title">Woof Woof</h1>
      </div>
    </div>
  );
}
